<div class="room-dialog">
  <p class="room-dialog__kicker">Host studio</p>
  <h2 class="room-dialog__title">Update room details</h2>
  <p class="room-dialog__note">
    Email admin if you need to change the room name or business LLC name.
  </p>

  <div class="room-dialog__name">
    <mat-icon>storefront</mat-icon>
    <span>{{ roomDTO?.roomName }}</span>
  </div>

  <label class="room-dialog__label" for="roomDescription">Room description</label>
  <textarea
    id="roomDescription"
    class="room-dialog__textarea"
    rows="4"
    [(ngModel)]="roomDTO.roomDescription"
    placeholder="Tell buyers what this room is about"></textarea>

  <div class="room-dialog__photos">
    <div class="photo-card">
      <img *ngIf="existingRoomImage" [src]="existingRoomImage" alt="Current room photo" />
      <div class="photo-card__empty" *ngIf="!existingRoomImage">
        <mat-icon>image</mat-icon>
      </div>
      <span>Current</span>
    </div>

    <div class="photo-card" *ngIf="imageSrcPreview">
      <img [src]="imageSrcPreview" alt="New room photo preview" />
      <span>New</span>
    </div>

    <button type="button" class="photo-upload" (click)="file.click()">
      <span class="photo-upload__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M5 19h14V8h-4.2l-1.4-2H10.6L9.2 8H5v11zm7-2.2A3.8 3.8 0 1 0 8.2 13 3.8 3.8 0 0 0 12 16.8z" fill="currentColor"/>
        </svg>
      </span>
      <span class="photo-upload__copy">
        <strong>Upload new photo</strong>
        <em>{{ fileToUpload ? fileToUpload.name : 'PNG or JPG' }}</em>
      </span>
    </button>
    <input type="file" #file accept="image/*" (change)="onRoomImageFileChange($event)" hidden />
  </div>

  <div class="room-dialog__actions">
    <button type="button" class="host-cta host-cta--ghost" (click)="onCancel()">Cancel</button>
    <button type="button" class="host-cta" (click)="onUpdate()">Save changes</button>
  </div>
</div>
